<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->

    <div class="right-menu">
      <search id="header-search" class="right-menu-item" />

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->
          <font-awesome-icon icon="user" /> <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu v-if="!currentUser" slot="dropdown">
          <router-link to="/login">
            <el-dropdown-item>{{ $t('navbar.login') }}</el-dropdown-item>
          </router-link>
          <router-link to="/register">
            <el-dropdown-item>{{ $t('navbar.register') }}</el-dropdown-item>
          </router-link>
        </el-dropdown-menu>
        <el-dropdown-menu v-else slot="dropdown">
          <router-link to="/profile">
            <el-dropdown-item>{{ $t('navbar.profile', {username: currentUser.username}) }}</el-dropdown-item>
          </router-link>
          <!-- <router-link to="/">
            <el-dropdown-item>Dashboard</el-dropdown-item>
          </router-link> -->
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">{{ $t('navbar.logout') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger';
import Search from '@/components/HeaderSearch';

export default {
    components: {
    // Breadcrumb,
        Hamburger,
        Search
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        ...mapGetters([
            'sidebar',
            'avatar',
            'device'
        ])
    },
    methods: {
        toggleSideBar() {
            this.$store.dispatch('app/toggleSideBar');
        },
        async logout() {
            await this.$store.dispatch('auth/logout');
            // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
            this.$router.push('/login');
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../styles/theme.scss";

.navbar {
 height: 50px;
 display: flex;
 align-items: center;
 justify-content: space-between;
 background-color: #fff;
 border-bottom: 1px solid $issue-border;
 box-shadow: $issue-shadow-sm;

 .right-menu {
     display: flex;
     align-items: center;
     height: 100%;
     padding-right: 16px;

     .right-menu-item {
         display: flex;
         align-items: center;
     }

     .el-dropdown {
         font-size: 19px;
         display: flex;
         align-items: center;
         height: 100%;
         .avatar-wrapper {
             display: flex;
             align-items: center;
             gap: 6px;
             margin-left: 14px;
             padding: 6px 10px;
             border-radius: $issue-radius-sm;
             cursor: pointer;
             font-size: 15px;
             color: $issue-text-muted;
             transition: background-color .12s ease, color .12s ease;

             &:hover {
                 background-color: $issue-bg-subtle;
                 color: $issue-text;
             }

             svg {
                 font-size: 16px;
             }
         }
     }

 }
 .hamburger-container {
   display: flex;
   align-items: center;
   justify-content: center;
   height: 100%;
   cursor: pointer;
   transition: background .3s;
   -webkit-tap-highlight-color:transparent;

   &:hover {
     background: $issue-bg-subtle;
   }
 }
}

// .navbar {
//   height: 50px;
//   overflow: hidden;
//   position: relative;
//   background: #fff;
//   box-shadow: 0 1px 4px rgba(0,21,41,.08);
//
//   .hamburger-container {
//     line-height: 46px;
//     height: 100%;
//     float: left;
//     cursor: pointer;
//     transition: background .3s;
//     -webkit-tap-highlight-color:transparent;
//
//     &:hover {
//       background: rgba(0, 0, 0, .025)
//     }
//   }
//
//   .breadcrumb-container {
//     float: left;
//   }
//
//   .errLog-container {
//     display: inline-block;
//     vertical-align: top;
//   }
//
//   .right-menu {
//     float: right;
//     height: 100%;
//     line-height: 50px;
//
//     &:focus {
//       outline: none;
//     }
//
//     .right-menu-item {
//       display: inline-block;
//       padding: 0 8px;
//       height: 100%;
//       font-size: 18px;
//       color: #5a5e66;
//       vertical-align: text-bottom;
//
//       &.hover-effect {
//         cursor: pointer;
//         transition: background .3s;
//
//         &:hover {
//           background: rgba(0, 0, 0, .025)
//         }
//       }
//     }
//
//     .avatar-container {
//       margin-right: 30px;
//
//       .avatar-wrapper {
//         margin-top: 5px;
//         position: relative;
//
//         .user-avatar {
//           cursor: pointer;
//           width: 40px;
//           height: 40px;
//           border-radius: 10px;
//         }
//
//         .el-icon-caret-bottom {
//           cursor: pointer;
//           position: absolute;
//           right: -20px;
//           top: 25px;
//           font-size: 12px;
//         }
//       }
//     }
//   }
// }
</style>
